import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  close() {
    this.dispatch('closed');
    this.element.remove();
  }
}
